module.exports = __webpack_public_path__ + "img/logo_w_text.3452a1b4.svg";